import PracticeMap from './PracticeMap';

export default PracticeMap;



// WEBPACK FOOTER //
// ./src/components/PracticeMap/index.js